<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <!--<el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>-->
            <!--<el-select style="width: 145px" @change="changeData($event,'state')" @clear="clearsearch('gs')" class="marr4" v-model="vc_checkstate" size="mini" clearable filterable :placeholder="$t('form_please_select')">
                <el-option
                        v-for="item in stateData"
                        :key="item.i_checkstate"
                        :label="item.vc_name"
                        :value="item.i_checkstate">
                </el-option>
            </el-select>-->
            <!--<el-select style="width: 145px"  @change="changeData($event,'fpt')"
                       @clear="clearsearch('fpt')" class="marr4" v-model="vc_type" size="mini" clearable
                       filterable :placeholder="$t('invoiceEntry_please_select_the_billing_type')">
                <el-option
                        v-for="item in fpType"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>-->
            <el-select style="width: 145px"  @change="changeData($event,'gs')"
                       @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable
                       filterable :placeholder="$t('form_please_select_a_company')">
                <el-option
                        v-for="item in compsData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <!--<el-input  class="marr4" style="width: 280px"  v-model="vc_search" :placeholder="$t('invoiceEntry_please_enter_customer_name/invoice_number/product_name/submitter_search')" clearable size="mini"></el-input>-->
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <!--<el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="savejp({},'pl')">{{'批量保存'}}</el-button>-->
            <!--<el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="submitjp({},'pl')">{{'批量提交'}}</el-button>-->
        </div>
        <el-table
                v-loading="loading"
                element-loading-text="处理时间较长,请不要刷新页面.."
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}">
                <!--@selection-change="handleSelectionChange"
                :row-key="row => row.i_subId"-->
            <!--<el-table-column
                    align="center"
                    type="selection"
                    :reserve-selection="true"
                    :selectable="checkSelectable"
                    width="50">
            </el-table-column>-->
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="'公司'"
                    show-overflow-tooltip
                    min-width="145">
            </el-table-column>
            <el-table-column
                    prop="dt_time"
                    :label="'最近结账年月'"
                    show-overflow-tooltip
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="'最近操作人'"
                    show-overflow-tooltip
                    width="110">
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    :label="'最近操作时间'"
                    show-overflow-tooltip
                    width="165">
            </el-table-column>
            <el-table-column
                    prop="i_state"
                    :label="'状态'"
                    show-overflow-tooltip
                    width="140">
                <template slot-scope="scope">
                    <span>{{scope.row.i_state==0?'结账中':(scope.row.i_state==1?'业务系统已结帐':(scope.row.i_state==2?'财务系统已结帐':(scope.row.i_state==-1?'取消结账':(scope.row.i_state==3?'反结账中':''))))}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="200"
                    :label="$t('form_operate')"
                    fixed='right'>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.i_state==1" style="color: red" type="text" size="small" @click="savejp(scope.row,'re')">{{'取消结账'}}</el-button>
                    <el-button v-if="scope.row.i_state==1"  type="text" size="small" @click="savejp(scope.row,'next')">{{'结转下月'}}</el-button>
                    <el-button v-if="scope.row.i_state==3"  type="text" size="small" @click="savejp(scope.row,'again')" >{{'重新结账'}}</el-button>
                    <el-button v-if="scope.row.i_state==1" style="color: #0a6332" type="text" size="small" @click="jzglFun(scope.row)">研发处理</el-button>

                </template>
            </el-table-column>
        </el-table>
        <!--<el-pagination
                class="fr mrr9"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>-->
        <div :class="baseerp+'div'">
            <el-dialog class="cldialog" style="display: flex;justify-content: center;align-items: center;"
                    width="90%" top="30"  :title="detailTitle" :visible.sync="detailDialog"
                    v-if="detailDialog" :close-on-click-modal="false" @close="detailClose">
                <detail-page :data="detailData" @close="detailClose"></detail-page>
            </el-dialog>
        </div>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import DetailPage from "./DetailPage"
    export default {
        components: {DetailPage},
        data() {
            return {
                maxDialogHeight: 0,
                tableHeight:0,
                tableData:[{}],
                multipleSelection:[],
                baseerp:"",
                file_root:"",
                mid:0,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                loading:false,
                subData:[],
                gosave:false,
                //valuetime:'',
                //dt_startdate:'',
                //dt_enddate:'',
                compsData:[],
                companyId:0,
                companyName:'',
                detailDialog:false,
                detailData:{},
                detailTitle:'研发支出管理',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            this.getList();
            this.getCompanyList();
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            jzglFun(row){
                this.detailDialog=true;
                this.detailData=row
            },
            detailClose(type='back'){
                if(type=='save'){
                    this.getList()
                }
                this.detailDialog=false;

            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h;
            },

            checkSelectable(row, index) {
                if (row.i_open_price_state != 1) return true;
            },
            savejp(row,type){
                let tip='',jztime='';
                if(type=='next'){tip='是否确认结转下月,如确认结转,处理时间较长,请耐心等待不要刷新页面';jztime=this.getjztime(row.dt_time)};
                if(type=='again'){tip='是否确认重新结账';jztime=row.dt_time+'-01'};
                if(type=='re'){tip='是否确认取消结账';jztime=row.dt_time+'-01'};
                row.jztime=jztime;
                this.$confirm(tip, this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.saveorupdateOpenPrice(row,type);
                }).catch(() => {

                });
            },
            getjztime(timeStr){
                // 步骤1：分割年、月（直接解析4位年份，无需额外处理）
                const [year, month] = timeStr.split('-').map(Number);
                // JS Date月份是0-11，所以月份减1；日期设为1（对应最终的'-01'）
                const date = new Date(year, month - 1, 1);
                // 步骤2：加1个月（自动处理12月→次年1月的进位）
                date.setMonth(date.getMonth() + 1);
                // 步骤3：格式化输出（确保月为两位数，拼接'-01'）
                const resultYear = date.getFullYear(); // 直接取4位年份（2025→2025）
                const resultMonth = String(date.getMonth() + 1).padStart(2, '0'); // 月份加1后补零
                const result = `${resultYear}-${resultMonth}-01`;
                return result;
            },
            async saveorupdateOpenPrice(row,type) {
                this.loading = true;
                let param1 = {
                    i_mid: this.mid,
                    i_gsid:row.i_gsid,
                    dt_time:row.jztime,
                    isredo:type=='next'?0:1,
                    i_id:type=='again'?row.i_id:null,
                    i_isvalid_energy:row.i_isvalid_energy,
                };
                let param2 = {
                    i_mid: this.mid,
                    i_gsid:row.i_gsid,
                    dt_time:row.jztime,
                    i_id:row.i_id,
                };
                let res;
                if(type=='next'||type=='again')res = await API.monthCarry(param1);
                if(type=='re')res = await API.monthCarryUnDo(param2);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.gosave = false;
                    //this.multipleSelection=[];
                    //this.tableData.map((item,index)=>{
                    //    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                    //})
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList()
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            handleSelectionChange(currentSelectedRows) {
                this.multipleSelection=currentSelectedRows;
            },
            async getCompanyList(){
                let param = {
                    i_mid:this.mid,
                    type:'0,2',
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeData(e,type){
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                    }else{
                        this.companyName='';
                    }
                }
                //this.getList();
            },
            gosearch(){
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    //'i_state':this.i_state,
                    //'dt_startdate':this.dt_startdate,
                    //'dt_enddate':this.dt_enddate,
                    //"vc_search": this.vc_search,
                    //"currentPage":this.currentPage,
                    //"pageSize": this.pageSize,
                    "i_gsid":this.companyId?this.companyId:0,
                };
                let res = await API.list(param);
                //let res={code:1,data:[{i_id:1,i_state:0,dt_time:'2025-11'},{i_id:2,i_state:1,dt_time:'2025-11'},{i_id:3,i_state:2,dt_time:'2025-11'}],total:3}
                if (res.code==1){
                    this.tableData=res.data;
                    this.tableTotal=res.total;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
        },
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-dialog__body{
        /*max-height: 400px !important;*/
        /*overflow-y: auto !important;*/
        padding: 20px 20px;
    }
    /deep/ .el-table__header-wrapper th .cell .el-checkbox {
        display: none;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .pad14{
        padding: 4px;
    }
    .alc{
        align-items: center;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }

</style>